export const SHOULD_OPEN_OFFER_MODAL = 'shouldOpenOfferModal';
export const SHOULD_OPEN_PLACE_BID_MODAL = 'shouldOpenPlaceBidModal';
export const SHOULD_OPEN_REQUESTS_SLIDEOUT = 'shouldOpenRequestsSlideout';
export const SHOULD_SHOW_REQUESTS_ONBOARDING = 'shouldShowRequestsOnboarding';
export const EQUINOX_UUID = 'equinox_uuid';
export const IS_TIMEZONE_SENT = 'isTimezoneSent';
